<template>
  <div :class="['definition-wrapper', 'chart', 'geo-chart', {'error_validate': mandatoryValidation}]">
    <GChart v-if="componentMounted"
      type="GeoChart"
      :data="chartData"
      :options="chartOptions"
      :settings="chartSettings"
    />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'
import transport from 'vue-definition-utils/src/utils/transport'
import language from '../../language'

export default {
  name: 'definition-geo-chart',
  props: [
    'definition',
    'object',
    'definitionObject',
    'editable',
    'mandatoryValidation',
    'definitionId',
    'definitionContentId',
    'repeatableGroupCode',
    'requestObjectForAdd',
    'requestObjectForAddModified',
    'apiparams',
    'language',
    'callTask'
  ],
  components: {
    GChart
  },
  data () {
    return {
      componentMounted: false,
      chartData: [],
      chartOptions: {},
      chartSettings: {}
    }
  },
  methods: {
  },
  beforeMount () {
    this.object.chartValue = {
      region: {
        region: 'ES',
        displayMode: 'markers'
      },
      header: [
        {
          type: 'string',
          label: 'Ciudad'
        },
        {
          type: 'number',
          label: 'Individuios contactables'
        },
        {
          type: 'number',
          label: 'Individuos'
        }
      ],
      data: [
        [
          'Madrid', 200000, 3000000
        ],
        [
          'Barcelona', 100000, 1600000
        ],
        [
          'Valencia', 50000, 400000
        ],
        [
          'Sevilla', 40000, 350000
        ],
        [
          'Granada', 5000, 125000
        ],
        [
          'Vigo', 3000, 80000
        ],
        [
          'Las Palmas de Gran Canaria', 50000, 80000
        ],
        [
          'Oviedo', 15000, 23000
        ],
        [
          'Bilbao', 50000, 80000
        ],
        [
          'Zaragoza', 2000, 250000
        ],
        [
          'Tarragona', 30000, 300000
        ],
        [
          'Lleida', 25000, 250000
        ],
        [
          'Girona', 50000, 400000
        ]
      ]
    }
    var dataChart = transport.methods.getDataChart(JSON.parse(JSON.stringify(this.object.chartValue)))
    this.chartData = dataChart.chartData

    this.chartOptions = this.object.chartValue.region
    this.chartOptions.colorAxis = {colors: ['green', 'blue']}
    this.chartOptions.width = '100%'
    this.chartOptions.height = 500
    this.chartOptions.fontSize = 16

    this.chartSettings.mapsApiKey = this.apiparams.mapsKey
    this.chartSettings.packages = ['corechart', 'map']
    this.chartSettings.language = language(this.language, 'chart')

    this.componentMounted = true
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content/definitionLoader/item/chart/geoChart.vue